var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "common_contents_wrap", attrs: { id: "about" } },
      [
        _c("h2", [_vm._v("ABOUT")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n\t\tここは管理人ＡＲＡＩのホムペです！"),
          _c("br"),
          _vm._v("\n\t\t一部ジャバスクリプト、ＰＮＧ画像を使用しています。"),
          _c("br"),
          _vm._v(
            "\n\t\tご連絡は、ＣＯＮＴＡＣＴからどうぞ！質問、激励、苦情など・・・なんでもお気軽にメールください！"
          ),
          _c("br"),
          _vm._v(
            "\n\t\t当ホムペはリンク自由です。が、連絡もらえると私が喜びます（笑）\n\t"
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "about_practical_text" }, [
          _vm._v("\n\t\tというテイストで作成したポートフォリオです。"),
          _c("br"),
          _vm._v(
            "\n\t\t最初は、自分のスキル不足を補うため＆自ら学び・アウトプットができる人間であることを転職でアピールするためにVue.js+Firebaseでサイトを作り始めたのですが、作っているうちに自分が小学生の頃に好きだったweb黎明期のホームページを再現したくなってしまい、キリ番BBSを作ったりリンク集を作ったりしているうちに20年ぶりにインターネットに触れた人が作った謎のサイトなのか、真剣に作ったポートフォリオなのか、大変わかりづらいものとなってしまいました。が、真剣に作ったポートフォリオです。絶賛転職先探し中です。気になった企業様はCONTACTからご連絡お願いします。\n\t"
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }